import { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ListTodo, Plus } from 'lucide-react';
import { TaskRow } from './TaskRow';
import { TaskDialog } from './TaskDialog';
import { useTasks } from './useTasks';

export function TasksPanel({ leadId, buyerId }) {
  const { tasks, reload, toggle, remove, snooze } = useTasks(leadId ? { lead_id: leadId } : { buyer_id: buyerId });
  const [dialog, setDialog] = useState(null);
  const [showDone, setShowDone] = useState(false);
  const open = tasks.filter(t => !t.done);
  const done = tasks.filter(t => t.done);

  return (
    <Card className="bg-white border-gray-200 shadow-sm" data-testid="tasks-panel">
      <CardContent className="p-5 space-y-3">
        <div className="flex items-center justify-between">
          <p className="text-sm font-semibold text-gray-900 flex items-center gap-2"><ListTodo className="h-4 w-4 text-[#0073ea]" /> Tasks & Reminders <span className="text-gray-400 font-normal">{open.length} open</span></p>
          <Button size="sm" data-testid="panel-add-task-btn" onClick={() => setDialog({})} className="bg-[#0073ea] hover:bg-[#0060c2] text-white"><Plus className="h-3.5 w-3.5 mr-1" /> Add Task</Button>
        </div>
        {open.length === 0 && <p className="text-sm text-gray-400 text-center py-3">No open tasks</p>}
        <div className="space-y-1.5">
          {open.map(t => <TaskRow key={t.id} task={t} onToggle={toggle} onEdit={(x) => setDialog({ task: x })} onDelete={remove} onSnooze={snooze} showLink={false} />)}
        </div>
        {done.length > 0 && (
          <button data-testid="panel-toggle-done" onClick={() => setShowDone(!showDone)} className="text-xs text-gray-500 hover:text-gray-900">{showDone ? 'Hide' : 'Show'} {done.length} completed</button>
        )}
        {showDone && <div className="space-y-1.5">{done.map(t => <TaskRow key={t.id} task={t} onToggle={toggle} onEdit={(x) => setDialog({ task: x })} onDelete={remove} showLink={false} />)}</div>}
      </CardContent>
      <TaskDialog open={!!dialog} onOpenChange={v => !v && setDialog(null)} task={dialog?.task} leadId={leadId} buyerId={buyerId} onSaved={reload} />
    </Card>
  );
}
